import { render, staticRenderFns } from "./UnSeoText.vue?vue&type=template&id=20788856&lang=pug&"
import script from "./UnSeoText.vue?vue&type=script&lang=js&"
export * from "./UnSeoText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports